import { B as Build } from './index-5faac9d7.js';

const isBrowser = () => Build.isBrowser;
function isMobile() {
  const desktopBreakpoint = 980;
  return window.innerWidth < desktopBreakpoint;
}

export { isBrowser as a, isMobile as i };
